import React, { useEffect } from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const DesktopAdhesion = /*#__PURE__*/ React.memo(({ safety ='unlikely'  })=>{
    const slotAttr = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['DesktopAdhesion'], safety, {
        refreshLimit: 30,
        refreshTime: 30,
        format: 'anchor',
        anchor: 'bottom',
        anchorPersistClose: false,
        report: {
            enabled: false
        },
        mediaQuery: '(min-width: 1025px), (min-width: 768px) and (max-width: 1024px), (min-width: 320px) and (max-width: 767px)'
    });
    useEffect(()=>{
        if (slotAttr.advertIsOff) {
            var ref;
            const slot = document.getElementById(ADUNIT_MAP['DesktopAdhesion']);
            slot === null || slot === void 0 ? void 0 : (ref = slot.parentElement) === null || ref === void 0 ? void 0 : ref.removeChild(slot);
        }
    }, [
        slotAttr.advertIsOff
    ]);
    return null; // anchors DONT need a div
}, adunitMemo);
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
